module.exports = __webpack_public_path__ + "img/sj.5b6dddaf.svg";